// List of allowed countries for autocomplete filtering
export const ALLOWED_COUNTRY_CODES = [
  'FR', // France
  'BE', // Belgium
  'CH', // Switzerland
  'LU', // Luxembourg
  'MC', // Monaco
  'AD', // Andorra
  'RE', // Réunion
  'GP', // Guadeloupe
  'MQ', // Martinique
  'GF', // French Guiana
  'YT', // Mayotte
  'NC', // New Caledonia
  'PF', // French Polynesia
  'WF', // Wallis and Futuna
  'PM', // Saint Pierre and Miquelon
  'MF', // Saint Martin
  'BL' // Saint Barthélemy
]
